const storage = window.localStorage;

/**
 *
 * @param key
 * @param value
 * @param overdue 过期时间 （天）
 */
function set(key, value, overdue) {
  if(overdue && !isNaN(overdue)) {
    let time = +new Date();
    storage.setItem(key, JSON.stringify({ value, overdue, time }))
  } else {
    storage.setItem(key, JSON.stringify({ value }))
  }
}

/**
 *
 * @param key
 */
function get(key) {
  let value = storage.getItem(key);
  try {
    value = JSON.parse(value);
  } catch(e) {
    value = (new Function('return ' + value))();
  }
  if(({}).toString.call(value) === '[object Object]') {
    if(value.overdue) {
      let diffTime = +new Date() - value.overdue * 8.64e7;
      if(diffTime > value.time) {
        value = null;
        clear(key);
      } else {
        value = value.value;
      }
    } else {
      value = value.value;
    }
  }
  return value;
}

function clear(key) {
  if(key) {
    storage.removeItem(key)
  } else {
    storage.clear();
  }
}

export default { set, get, clear };







// WEBPACK FOOTER //
// ./src/storage/storage.js